import Vue from 'vue';
import axios from 'axios';
import store from '@/store'
import { MessageBox ,Loading} from 'element-ui';
import interfaces from './interface.js';
import QS from 'qs'
import router from '../router'
import VueCookies from "vue-cookies";
import database from "../utils/data";


const appApiUrlTest =       'https://t2.miaocang.cc';//app测试环境api
const appApiUrl =           'http://api.miaocang.cc';//app正式环境api

// const serviceUrl =          'http://120.24.5.75:8989/zs-miaocangapp-web';//正式环境接口后端api
// const serviceDomain =       'http://120.24.5.75:8989';//正式环境接口后端域名
/* 正式环境 新地址 */
const serviceUrl =          'http://121.40.208.95:8989/zs-miaocangapp-web';//正式环境接口后端api
const serviceDomain =       'http://121.40.208.95:8989';//正式环境接口后端域名

// const serviceUrlTest =      'http://192.168.0.221:8088/zs-miaocangapp-web';//测试环境接口后端api
// const serviceDomainTest =   'http://192.168.0.221:8088/';//测试环境接口后端域名
/* 测试环境 新地址 */
const serviceUrlTest =      'http://pctest.miaocang.cc/zs-miaocangapp-web';//测试环境接口后端api
const serviceDomainTest =   'http://pctest.miaocang.cc/';//测试环境接口后端域名

// const serviceUrl = '/proxy'

axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = serviceDomainTest
} else if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = serviceDomainTest
} else if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = ''
}

let authReject = false;
/*
//http request 拦截器
axios.interceptors.request.use(
    config => {
        const req = Object.assign({}, config);
        req.headers['Content-Type'] = 'application/x-www-form-urlencoded';

        // const map = interfaces[req.url]
        const map = req.url;
        let url = '';
        let method = 'post';
        // 是否存在|
        if (/\|/.test(map)) {
            const [prev, tail] = map.split('|');
            url = tail;
            if (prev === 'get') {
                method = 'get'
            } else if (prev === 'json') {
                req.headers['Content-Type'] = 'application/json'
                // url = addParam(tail,'sid',Vue.prototype.$db.session.get('sid'));//json操作要加sid,放json会被拦截器清空
            } else if (prev === 'upload') {
                req.headers['Content-Type'] = 'multipart/form-data'
            }
        } else {
            url = map
        }


        req.method = method;
        req.url = url;

        return req
    },
    error => {
        // 抛给http的catch
        return Promise.reject(error)
    }
);
*/

//响应拦截器即异常处理
axios.interceptors.response.use(
    response => response,
    err => {
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    console.log('错误请求');
                    break;
                case 401:
                    console.log('未授权，请重新登录');
                    break;
                case 403:
                    console.log('拒绝访问');
                    break;
                case 404:
                    console.log('请求错误,未找到该资源');
                    break;
                case 405:
                    console.log('请求方法未允许');
                    break;
                case 408:
                    console.log('请求超时');
                    break;
                case 500:
                    console.log('服务器端出错');
                    break;
                case 501:
                    console.log('网络未实现');
                    break;
                case 502:
                    console.log('网络错误');
                    break;
                case 503:
                    console.log('服务不可用');
                    break;
                case 504:
                    console.log('网络超时');
                    break;
                case 505:
                    console.log('http版本不支持该请求');
                    break;
                default:
                    console.log('连接错误');
                    console.log(err.response);
            }
        }
        else if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1 ) {
            return Promise.reject('网络繁忙，请稍后重试');
        }else {
            console.log('连接到服务器失败')
        }
        return Promise.reject(err);
    }
);

export default {
    getApiInterfaces(){
        return interfaces;
    },
    getAppApiHost(){
        if (process.env.NODE_ENV === 'development') {
            return appApiUrlTest
        } else if (process.env.NODE_ENV === 'debug') {
            return appApiUrlTest
        } else if (process.env.NODE_ENV === 'production') {
            return appApiUrl;
        }
    },
	getApiServiceHost(){
        if (process.env.NODE_ENV === 'development') {
            return serviceUrlTest
        } else if (process.env.NODE_ENV === 'debug') {
            return serviceUrlTest
        } else if (process.env.NODE_ENV === 'production') {
            return serviceUrl
        }
	},
    getApiServiceDomain(){
        if (process.env.NODE_ENV === 'development') {
            return serviceDomainTest
        } else if (process.env.NODE_ENV === 'debug') {
            return serviceDomainTest
        } else if (process.env.NODE_ENV === 'production') {
            return serviceDomain
            // return serviceDomainTest
        }
    },
	post(url,data,loadingFlag = true,loadingTips = '载入中...',showErr = true) {
		let loading = null;
		if (loadingFlag) {
		    loading = Loading.service({
		        lock: true,
		        text: loadingTips,
		        spinner: 'el-icon-loading',
		        background: 'rgba(0, 0, 0, 0.5)'
		    })
		}
        let sid = Vue.$cookies.get('sid');
        let build = '3009000';
        let platform = 'PC';
        let app_version = '3.9.0';
		if(typeof store().state !=="undefined"){
            build = store().state.app_build;
            platform = store().state.app_platform;
            app_version = store().state.app_version;
        }
        if(typeof data ==="object"){
            if(data instanceof FormData){
                data.append('sid',sid);
                data.append('build',build);
                data.append('platform',platform);
                data.append('app_version',app_version);
            }else{
                data.sid = sid;
                data.build = build;
                data.platform = platform;
                data.app_version = app_version;
            }
        }
		return new Promise((resolve, reject)=> {
		    let realUrl = interfaces[url];
		    let ContentType = 'application/x-www-form-urlencoded';
		    if(typeof data ==="object"){
		        if(data instanceof FormData)
                    ContentType = 'multipart/form-data';
		        else{
		            //根据特殊字段做json传输处理
		            if(data.requestPostJson){
                        ContentType = 'application/json';
                        realUrl += "?sid="+ data.sid;
                        data = JSON.stringify(data);
                    }
                }
            }
		    // else
            //     ContentType = 'application/x-www-form-urlencoded';
            axios({
                url: realUrl,
                method: 'post',
                data: data,
                transformRequest: [
                    function(data) {
                        // Do whatever you want to transform the data
                        if(ContentType==='application/x-www-form-urlencoded'){
                            let ret = '';
                            for (let it in data) {
                                // 如果要发送中文 编码
                                ret +=
                                    encodeURIComponent(it) +
                                    '=' +
                                    encodeURIComponent(data[it]) +
                                    '&'
                            }
                            return ret;
                        }else
                            return data;
                    }
                ],
                headers: {
                    'Content-Type': ContentType
                },
                // cancelToken: new axios.CancelToken(function (cancel) {
                //     if(typeof(Vue)!=="undefined" && typeof(Vue.Cancel)!=="undefined")
                //         Vue.Cancel && Vue.Cancel.push(cancel)
                // })
            }).then(response => {
				if (loadingFlag && loading) {
					loading.close()
				}
                /**
                 * 这里统一做code判断，逻辑层就不用再catch提示了
                 */
                if(typeof response.data.code !=="undefined" && response.data.code!==0){
                    if(authReject){
                        reject();
                        return;
                    }
                    if(response.data.code===1006){
                        MessageBox.alert(response.data.errMsg,'用户验证',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning',
                            callback:function () {
                                Vue.$cookies.remove('is-login');
                                Vue.$cookies.remove('sid');
                                database.session.remove('sid');
                                database.session.remove('user_name');
                                database.local.remove('user');
                                database.local.remove('company');
                                database.local.remove('warehouseList');
                                console.log(router);
                                // if(router.get!=='login'){
                                    router.replace({
                                        name: 'login',
                                        query: this.$route.query
                                    });
                                // }
                            }
                        });
                    }
                    else if(showErr){
                        let errMsg = "异常错误，请联系管理员!";
                        if(typeof response.data.errMsg !=="undefined" && response.data.errMsg)
                            errMsg = response.data.errMsg
                        // errMsg += "code:"+response.data.code;
                        console.log("response code:"+response.data.code);
                        MessageBox.alert(errMsg,'错误',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning',
                            callback:function(){
                                authReject = false;
                            }
                        });
                    }
                    authReject = true;
                    reject();
                }else{
                    authReject = false;
                    resolve(response.data);
                }
			}).catch(err => {
                if (loadingFlag && loading) {
                    loading.close()
                }
                /**
                 * 这里统一做判断，逻辑层就不用再catch提示了
                 */
                if(!authReject){
                    authReject = true;
                    MessageBox.alert(err,'错误',{
                        confirmButtonText:'确定',
                        showCancelButton:false,
                        type:'error',
                        callback:function(){
                            authReject = false;
                        }
                    });
                }
                reject();
            });
		})
	},
	get(url,data,loadingFlag = true,loadingTips = '载入中...') {
		let loading = null;
		if (loadingFlag) {
		    loading = Loading.service({
		        lock: true,
		        text: loadingTips,
		        spinner: 'el-icon-loading',
		        background: 'rgba(0, 0, 0, 0.5)'
		    })
		}
        data.sid = Vue.$cookies.get('sid');
        data.build = Vue.$store.state.app_build;
        // data.build = '3009000';
        data.platform = Vue.$store.state.app_platform;
        // data.platform = 'PC';
        data.app_version = Vue.$store.state.app_version;
        // data.app_version = '3.9.0';
		
		return new Promise((resolve, reject)=> {
			axios.get(interfaces[url],data).then(response => {
				if (loadingFlag && loading) {
				    loading.close()
				}
                //统一code判断
                if(typeof response.data.code !=="undefined" && response.data.code!==0){
                    if(response.data.code===1006){
                        MessageBox.alert(response.data.errMsg,'用户验证',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning',
                            callback:function () {
                                Vue.$cookies.remove('is-login');
                                Vue.$cookies.remove('sid');
                                database.session.remove('sid');
                                database.session.remove('user_name');
                                database.local.remove('user');
                                database.local.remove('company');
                                database.local.remove('warehouseList');
                                if(router.path!=='login'){
                                    router.replace({
                                        name: 'login',
                                        query: this.$route.query
                                    });
                                }
                            }
                        });
                    }else{
                        let errMsg = "异常错误，请联系管理员!";
                        if(typeof response.data.errMsg !=="undefined" && response.data.errMsg)
                            errMsg = response.data.errMsg
                        // errMsg += "code:"+response.data.code;
                        console.log("response code:"+response.data.code);
                        MessageBox.alert(errMsg,'错误',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning'
                        });
                    }
                    reject();
                }else{
                    resolve(response.data);
                }
			}).catch(err => {
				if (loadingFlag && loading) {
				    loading.close()
				}
                MessageBox.alert(err,'错误',{
				    confirmButtonText:'确定',
				    showCancelButton:false,
				    type:'warning'
				});
				reject();
			})
		})
	},
    exportExcel(url,data,loadingFlag = true,loadingTips = '载入中...',showErr = true) {
        let loading = null;
        if (loadingFlag) {
            loading = Loading.service({
                lock: true,
                text: loadingTips,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            })
        }
        let sid = Vue.$cookies.get('sid');
        let build = '3009000';
        let platform = 'PC';
        let app_version = '3.9.0';
        if(typeof store().state !=="undefined"){
            build = store().state.app_build;
            platform = store().state.app_platform;
            app_version = store().state.app_version;
        }
        if(typeof data ==="object"){
            if(data instanceof FormData){
                data.append('sid',sid);
                data.append('build',build);
                data.append('platform',platform);
                data.append('app_version',app_version);
            }else{
                data.sid = sid;
                data.build = build;
                data.platform = platform;
                data.app_version = app_version;
            }
        }
        return new Promise((resolve, reject)=> {
            let realUrl = interfaces[url];
            let ContentType = 'application/x-www-form-urlencoded';
            if(typeof data ==="object"){
                if(data instanceof FormData)
                    ContentType = 'multipart/form-data';
                else{
                    //根据特殊字段做json传输处理
                    if(data.requestPostJson){
                        ContentType = 'application/json';
                        realUrl += "?sid="+ data.sid;
                        data = JSON.stringify(data);
                    }
                }
            }
            // else
            //     ContentType = 'application/x-www-form-urlencoded';
            axios({
                url: realUrl,
                method: 'post',
                data: data,
                responseType: 'blob',
                transformRequest: [
                    function(data) {
                        // Do whatever you want to transform the data
                        if(ContentType==='application/x-www-form-urlencoded'){
                            let ret = '';
                            for (let it in data) {
                                // 如果要发送中文 编码
                                ret +=
                                    encodeURIComponent(it) +
                                    '=' +
                                    encodeURIComponent(data[it]) +
                                    '&'
                            }
                            return ret;
                        }else
                            return data;
                    }
                ],
                headers: {
                    'Content-Type': ContentType
                },
                cancelToken: new axios.CancelToken(function (cancel) {
                    if(typeof(Vue)!=="undefined" && typeof(Vue.Cancel)!=="undefined")
                        Vue.Cancel && Vue.Cancel.push(cancel)
                })
            }).then(response => {
                if (loadingFlag && loading) {
                    loading.close()
                }
                /**
                 * 这里统一做code判断，逻辑层就不用再catch提示了
                 */
                if(typeof response.data.code !=="undefined" && response.data.code!==0){
                    if(response.data.code===1006){
                        MessageBox.alert(response.data.errMsg,'用户验证',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning',
                            callback:function () {
                                Vue.$cookies.remove('is-login');
                                Vue.$cookies.remove('sid');
                                database.session.remove('sid');
                                database.session.remove('user_name');
                                database.local.remove('user');
                                database.local.remove('company');
                                if(router.path!=='login'){
                                    router.replace({
                                        name: 'login',
                                        query: this.$route.query
                                    });
                                }
                            }
                        });
                    }
                    else if(showErr){
                        let errMsg = "异常错误，请联系管理员!";
                        if(typeof response.data.errMsg !=="undefined" && response.data.errMsg)
                            errMsg = response.data.errMsg;
                        errMsg += "code:"+response.data.code;
                        MessageBox.alert(errMsg,'错误',{
                            confirmButtonText:'确定',
                            showCancelButton:false,
                            type:'warning'
                        });
                    }
                    reject();
                }else{
                    resolve(response.data);
                    let blob = new Blob([response.data], {
                        type: 'application/vnd.ms-excel'
                    });
                    let fileName = Date.parse(new Date()) + '.xlsx';
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        //释放内存
                        window.URL.revokeObjectURL(link.href);
                    }
                }
            }).catch(err => {
                if (loadingFlag && loading) {
                    loading.close()
                }
                /**
                 * 这里统一做判断，逻辑层就不用再catch提示了
                 */
                MessageBox.alert(err,'错误',{
                    confirmButtonText:'确定',
                    showCancelButton:false,
                    type:'error'
                });
                reject();
            });
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/api.js